const eventsCheckoutNames = {
	openStore: 'begin_checkout',
	paymentOpenClick: 'click-redirect-to-payment-form',
	paymentOnSelectPack: 'click-switch-price',
	beginCheckout: 'begin_checkout_pay_form',
	promocodeApplied: 'promocode-applied',
	// TODO: should be removed
	// duplicate OpenStore/BeginCheckout with the reason DigitalCopy
	// k.eremeev@sdventures.com asked to leave temporary
	openDigitalCopySubscription: 'begin-checkout-digital-copy-chat-ai',
	beginCheckoutDigitalCopy: 'click-activate-access-btn-paywall-digital-copy-ai',
	beginCheckoutPopupShow: 'begin_checkout_popup_show',
	beginCheckoutPopupClickBack: 'begin_checkout_popup_click_back',
	beginCheckoutPopupClickDecline: 'begin_checkout_popup_click_decline',
};

export default eventsCheckoutNames;
